export const Link = {
	linkText: 'var(--epods--color-text-primary-action)',
	linkVisited: 'var(--epods--link-visited)',
	linkHover: 'var(--epods--link-hover)',
	linkActive: 'var(--epods--link-active)',
};

export const CustomLink = {
	linkTextFamily: 'var(--epods--font-secondary)',
	linkTextSize: 'var(--epods--font-size-p)',
	linkTextHeight: 'var(--epods--line-height-p)',
	linkDisabled: 'var(--epods--link-disabled)',
	iconMargin: 'var(--epods--link-icon-margin)',
	iconSize: 'var(--epods--link-icon-size)',
};
